import React from "react";

function render(value) {
    if (typeof value === "string" || typeof value === "number") {
        return value;
    }

    if (isNaN(value)) {
        return '-';
    }

    return value;
}

export function Result(props){
    return(
        <>
            <div className="text-center">
                <h3 style={{fontWeight: 'bold',color: '#1F140C'}}>{props.text}</h3>
            </div>
            <div style={{margin: '0 auto', position:'relative', width: 'auto', height: '164px', borderRadius: '8px', textAlign: 'center', padding:'10px', marginTop: '50px'}} id={props.errorMargin}className={props.npsClass}>
                <span className="nps_r">NPS</span>
                <p style={{fontSize: '66px', fontFamily: "'Maven Pro', sans-serif", fontWeight: 'bold', marginTop: '33px', lineHeight: '110px'}}>{render(props.value)}</p>
            </div>
        </>
    );
}